import gql from 'graphql-tag'

export const UPDATE_CHANNEX_MAPPINGS_MUTATION = gql`
  mutation UpdateChannexMappings (
    $roomTypes: [ChannexRoomTypeMapInput!]!
    $ratePlans: [ChannexRatePlanMapInput!]!
  ) {
    updateChannexMappings (
      data: {
        roomTypes: $roomTypes
        ratePlans: $ratePlans
      }
    ) {
      roomTypes {
        id
        roomCategoryId
        channexRoomTypeId
        pushEnabled
      }
      ratePlans {
        id
        roomCategoryId
        roomTariffId
        channexRatePlanId
        pushEnabled
      }
    }
  }
`
